import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'loginUrl',
      'redirectUrl',
      'partnerUrl',
    ]),
  },
  methods: {
    saveRefAndRedirect(saverefUrl, actionUrl) {
      fetch(saverefUrl, { method: 'GET' })
        .then(() => {
          // aquí deberíamos comprobar si res.status !== 200 o !res.ok para
          // validar el estado de la respuesta, pero el servicio de api
          // de callback devuelve siempre 404, así que no comprobamos nada.
          window.location.href = actionUrl;
        })
        .catch((err) => console.error(err));
    },
    onClickLogin() {
      window.dataLayer.push({
        event: 'click_login',
        eventData: {
          im_location: 'comment',
        },
      });
      this.saveRefAndRedirect(`${this.redirectUrl}?op=saveref`, this.loginUrl);
    },
    onClickSubscription() {
      window.dataLayer.push({
        event: 'click_suscription',
        eventData: {
          im_location: 'comment',
          im_type: 'infoLibre',
        },
      });
      this.saveRefAndRedirect(`${this.redirectUrl}?op=saveref`, this.partnerUrl);
    },
  },
};
